import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    balanceTitle: 'Balance',
    payinTitle: 'Inflows',
    payoutTitle: 'Outflows',
    title: 'Overview',
  },
  fr: {
    balanceTitle: 'Solde',
    payinTitle: 'Entrées d’argent',
    payoutTitle: 'Sorties d’argent',
    title: 'Tableaux de bord',
  },
} as const);

export default locales;
